import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import router from './router'

console.info('[catalog] build', process.env.VUE_APP_BUILD_VERSION)

createApp(App)
	.use(router)
	.mount('#app')
